import React from "react";

import type { JSX } from "react";

interface RadioItem {
  value: string;
  label: string;
}

interface RadioListProps {
  optionList: RadioItem[];
  name: string;
  defaultChecked: string;
  onChange: (value: string) => void;
}

function RadioInput({
  name,
  label,
  value,
  isChecked,
  onChange,
}: RadioItem & {
  name: string;
  isChecked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}): JSX.Element {
  return (
    <label
      className="text-muted-foreground m-0 flex gap-[0.625rem] font-normal"
      htmlFor={value}
    >
      <input
        className="peer hidden"
        defaultChecked={isChecked}
        id={value}
        name={name}
        onChange={onChange}
        type="radio"
        value={value}
      />
      <div className="border-primary peer-checked:after:bg-primary relative flex size-[1.25rem] justify-center rounded-full border-2 after:absolute after:top-1/2 after:size-[0.625rem] after:-translate-y-1/2 after:rounded-full" />
      {label}
    </label>
  );
}

export default function RadioList({
  optionList,
  name,
  defaultChecked,
  onChange,
}: RadioListProps): JSX.Element {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    onChange(event.target.value);
  };

  return (
    <div className="flex flex-col items-start gap-[0.3125rem]">
      {optionList.map((option) => (
        <RadioInput
          key={option.value}
          isChecked={defaultChecked === option.value}
          label={option.label}
          name={name}
          onChange={handleChange}
          value={option.value}
        />
      ))}
    </div>
  );
}
